import apiClient from './client'
import type {
  CronMonitor,
  CronMonitorCreate,
  CronMonitorUpdate,
  CronMonitorListResponse,
  CronRunListResponse,
  HeartbeatURLResponse,
} from '../types'

export const cronApi = {
  listMonitors: async (
    appId: string,
    params?: { skip?: number; limit?: number }
  ): Promise<CronMonitorListResponse> => {
    const response = await apiClient.get<CronMonitorListResponse>(`/apps/${appId}/cron-monitors`, {
      params,
    })
    return response.data
  },

  getMonitor: async (appId: string, monitorId: string): Promise<CronMonitor> => {
    const response = await apiClient.get<CronMonitor>(`/apps/${appId}/cron-monitors/${monitorId}`)
    return response.data
  },

  createMonitor: async (appId: string, data: CronMonitorCreate): Promise<CronMonitor> => {
    const response = await apiClient.post<CronMonitor>(`/apps/${appId}/cron-monitors`, data)
    return response.data
  },

  updateMonitor: async (
    appId: string,
    monitorId: string,
    data: CronMonitorUpdate
  ): Promise<CronMonitor> => {
    const response = await apiClient.put<CronMonitor>(
      `/apps/${appId}/cron-monitors/${monitorId}`,
      data
    )
    return response.data
  },

  deleteMonitor: async (appId: string, monitorId: string): Promise<void> => {
    await apiClient.delete(`/apps/${appId}/cron-monitors/${monitorId}`)
  },

  listRuns: async (
    appId: string,
    monitorId: string,
    params?: { skip?: number; limit?: number }
  ): Promise<CronRunListResponse> => {
    const response = await apiClient.get<CronRunListResponse>(
      `/apps/${appId}/cron-monitors/${monitorId}/runs`,
      { params }
    )
    return response.data
  },

  getHeartbeatUrl: async (appId: string, monitorId: string): Promise<HeartbeatURLResponse> => {
    const response = await apiClient.get<HeartbeatURLResponse>(
      `/apps/${appId}/cron-monitors/${monitorId}/heartbeat-url`
    )
    return response.data
  },
}

export type { CronMonitor, CronMonitorCreate, CronMonitorUpdate }
